import * as curveTypes from '../curve';

export enum CurveCodec {
  None = 0,
  Trans = 306,
  Zip = 307,
}

export {curveTypes as curve};